/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {OMIT_CLICK_AWAY_LISTENER} from '../maps/constants';
import {IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Create GeoFence Icon component.
 */
export const CreateGeoFenceIcon = (props: IconProps) => {
  const {iconSize = IconSize.medium, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} className={OMIT_CLICK_AWAY_LISTENER} id='createGeoFenceMarker' height={iconSize} viewBox='0 0 21 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.7274 10.089C15.5456 10.7673 15.1074 11.6155 14.46 12.5531C13.8181 13.4827 12.994 14.4666 12.0762 15.4132C10.3943 17.1479 8.44414 18.7098 6.78721 19.58C5.78737 17.9979 4.87942 15.6701 4.29021 13.327C3.96867 12.0483 3.74697 10.7842 3.65586 9.65817C3.56396 8.52243 3.60856 7.56881 3.79031 6.89048C4.5561 4.03254 7.68815 1.37013 11.4 2.36473C15.1119 3.35932 16.4932 7.23106 15.7274 10.089Z'
        stroke={iconColor}
        strokeWidth='1.25' />
      <circle cx='9.65422' cy='8.88019' r='1.70102' transform='rotate(15 9.65422 8.88019)' fill={iconColor} />
      <path d='M9.80078 8.33398L6.87666 19.247' stroke={iconColor} strokeWidth='1.25' />
      <path d='M16.3683 15.7324V24.0004' stroke={iconColor} strokeWidth='1.25' />
      <path d='M12.2343 19.8672L20.5023 19.8672' stroke={iconColor} strokeWidth='1.25' />
    </svg>
  );
};
